/* CheckBoxEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputCheckboxControl = uiCore.Control.Boolean.InputCheckbox;

class CheckBoxEditor extends CommonEditor {
    constructor(options) {
        super(options);
    }

    _createInput() {
        return new InputCheckboxControl({
            darkTheme: true,
        });
    }

    loadValue(item) {
        const fieldValue = item[this._fieldName];
        this.initialData = fieldValue;
        this.input.setValue(fieldValue);
    }

    applyValue(item, state) {
        item[this._fieldName] = state;
    }

    hide() {}
    show() {}

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = CheckBoxEditor;
